"use client";

import { useMemo } from "react";

import { Card } from "@/components/card";

import { useSearch } from "../context/search-context";
import { ArticleListData } from "../services/article-list";
import { ArticleList } from "./article-list";

interface FilteredArticleListProps {
  articles: ArticleListData;
}

export function FilteredArticleList({ articles }: FilteredArticleListProps) {
  const { searchQuery, searching } = useSearch();

  const filteredArticles = useMemo(() => {
    if (!searchQuery.trim()) return articles;

    const query = searchQuery.toLowerCase();
    return articles.filter(
      (article) =>
        article.title?.toLowerCase().includes(query) ||
        article.description?.toLowerCase().includes(query)
    );
  }, [articles, searchQuery]);

  if (searching) {
    return <SearchLoading />;
  }

  return <ArticleList articles={filteredArticles} />;
}

const SearchLoading = () => {
  return <Card className="h-40 animate-pulse" />;
};
